import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { memo, ReactElement } from 'react';

export interface ListWalkNavigationProps {
  onNextItem?: () => void;
  onPreviousItem?: () => void;
}

/**
 * right/left buttons to navigate next/previous item in a list
 */
export const ListWalkNavigation = memo(function ({
  onNextItem,
  onPreviousItem,
}: ListWalkNavigationProps): ReactElement {
  return (
    <Box>
      <IconButton
        disabled={!onPreviousItem}
        size='large'
        edge='start'
        color='primary'
        aria-label='previousItem'
        onClick={onPreviousItem}
      >
        <ArrowBackIos />
      </IconButton>
      <IconButton
        disabled={!onNextItem}
        size='large'
        edge='start'
        color='primary'
        aria-label='nextItem'
        onClick={onNextItem}
      >
        <ArrowForwardIos />
      </IconButton>
    </Box>
  );
});
